import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Datepicker from 'vuejs-datepicker'
import { en, es, ptBR } from 'vuejs-datepicker/dist/locale'
import { TheMask } from 'vue-the-mask'
import { JWTService } from '@/shared/services/jwt'
import SinisterMechanicalWorkshop from '@/components/regulation/auto/mechanicalworkshop/sinistermechanicalworkshop.vue'

// import InsurerRepository from '@/shared/http/repositories/configuration/insurer'
// import StageRepository from '@/shared/http/repositories/configuration/stage'
// import RegulationTypeRepository from '@/shared/http/repositories/configuration/regulationtype'
import AutoTypeRepository from '@/shared/http/repositories/configuration/autotype'
import BrandRepository from '@/shared/http/repositories/configuration/brand'
import AutoModelRepository from '@/shared/http/repositories/configuration/automodel'
import RegulationAutoRepository from '@/shared/http/repositories/regulation/auto/regulationauto.js'
import BusinessTypeRepository from '@/shared/http/repositories/configuration/businesstype'

import SinisterRegisterModel from '@/shared/models/regulation/auto/sinisterregistermodel'
import ThirdModel from '@/shared/models/common/thirdmodel'

import RegisterForms from './register-form'
import SinisterMechanicalWorkshopForms from '@/components/regulation/auto/mechanicalworkshop/form/sinistermechanicalworkshop-form.js'

import InsuranceMixin from '@/store/module/insurance/mixin.js'
import StageMixin from '@/store/module/stage/mixin.js'
import AnalystMixin from '@/store/module/analyst/mixin.js'
import BudgetSystemMixin from '@/store/module/budgetsystem/mixin.js'
import RegulationMixin from '@/store/module/regulation/mixin'
import RegulationTypeMixin from '@/store/module/regulationtype/mixin'
import { actionTypes as RegulationActions } from '@/store/module/regulation/actions'
import { globalMutationTypes as RegulationMutations } from '@/store/module/regulation/mutations'
import AccountMixin from '@/store/module/account/mixin'

import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'Register',
  props: [ 'clear' ],
  mixins: [
    ActionsForm,
    InsuranceMixin,
    StageMixin,
    AnalystMixin,
    BudgetSystemMixin,
    RegulationMixin,
    RegulationTypeMixin,
    AccountMixin,
    PermissionMixin
  ],
  data () {
    return {
      roles: Roles,
      data: SinisterRegisterModel,
      form: RegisterForms,
      formMarchineWorkshop: SinisterMechanicalWorkshopForms,
      dataThird: ThirdModel,
      pollingBusinessType: null,
      pollingBrand: null,
      pollingAutoModel: null,
      en: en,
      es: es,
      ptBR: ptBR,
      mechanicalWorkshop: {},
      HasSiniter: false
    }
  },
  components: {
    Datepicker,
    TheMask,
    SinisterMechanicalWorkshop
  },
  watch: {
    regulationId: function (value) {
      this.form.regulationAutoID.value = value
    },
    // TODO RETIRAR APÓS REFACTOR
    clear: function () {
      this.onClear()
    },
    'form.regulationTypeID.value': function (regulationTypeID) {
      if (regulationTypeID) {
        if ((this.regulationtypes) && (this.regulationtypes.count) > 0) {
          var data = this.regulationtypes.data
          for (var i in data) {
            if (data[i].id === regulationTypeID && data[i].stageID) {
              this.form.stageID.value = data[i].stageID
            }
          }
        }
      }
    }
  },
  mounted () {
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    },
    getMechanicalWorkshopID: function () {
      var result = null
      var payload = JWTService.GetTokenPayload()
      if (payload != null && payload.MechanicalWorkshopID != null) {
        result = payload.MechanicalWorkshopID
      }
      return result
    },
    getAllInsurer: function () {
      var result = []
      if ((this.insurances) && (this.insurances.count) > 0) {
        var data = this.insurances.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.insuranceID.options = result
      }
      return result
    },
    getAllStage: function () {
      var result = []
      if ((this.stages) && (this.stages.count) > 0) {
        var data = this.stages.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.stageID.options = result
      }
      return result
    },
    getAllAnalyst: function () {
      var result = []
      if ((this.analysts) && (this.analysts.count) > 0) {
        var data = this.analysts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.responsibleID.options = result
      }
      return result
    },
    getAllBudgetSystem: function () {
      var result = []
      if ((this.budgetsystems) && (this.budgetsystems.count) > 0) {
        var data = this.budgetsystems.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.budgetSystemID.options = result
      }
      return result
    },
    getAllRegulationType: function () {
      var result = []
      if ((this.regulationtypes) && (this.regulationtypes.count) > 0) {
        var data = this.regulationtypes.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.regulationTypeID.options = result
      }
      return result
    }
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      if (this.mechanicalWorkshopID === null) {
        this.$refs.MechanicalWorkshop.onClear()
      }
      this.$refs.alert.Close()
    },
    onNew () {
      this.data.mechanicalWorkshopID = this.getMechanicalWorkshopID
    },
    onLoad () {
      this.getAllInsuranceByArea(process.env.AreaAutos)
      this.getAllStageByArea(process.env.AreaAutos)
      this.getAllAnalysts()
      this.getAllBudgetSystems()
      this.getAllRegulationTypeByArea(process.env.AreaAutos)
      // this.onLoadAllRegulationType()
      this.onLoadAllAutoType()
    },
    onCreate () {
      loading.push()
      if (this.data.mechanicalWorkshopID === null) {
        this.data.mechanicalWorkshopID = this.getMechanicalWorkshopID
      }
      RegulationAutoRepository.Create(this.data)
        .then((response) => {
          this.onResult(response, true, true)
          // TODO REMOVER APÓS IMPLEMENTAÇÃO CORRETA
          if (response) {
            this.form.id.value = response.data.data.id
            this.$store.commit(RegulationMutations.SET_REGULATION, response.data.data)
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      if (this.data.mechanicalWorkshopID === null) {
        this.data.mechanicalWorkshopID = this.getMechanicalWorkshopID
      }
      RegulationAutoRepository.Update(this.data)
        .then((response) => {
          this.onResult(response, true, true)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      this.onClear()
      if (obj) {
        var self = this
        // DADOS SINISTROS e DADOS PARECER E RECLAMADO
        Tools.SetValueInForm(self.form, self.data, obj)

        this.HasSiniter = false

        // TIPO DE NEGÓCIO
        this.onChangeInsurance()
        this.pollingBusinessType = setInterval(() => {
          this.setBusinessType(obj.businessTypeID)
        }, 500)

        // FORÇA ESTAGIO ORIGINAL
        setTimeout(() => {
          this.form.stageID.value = obj.stageID
        }, 600)

        // DADOS OFICINA
        if (self.$refs.MechanicalWorkshop) {
          self.$refs.MechanicalWorkshop.onEditById(obj.mechanicalWorkshopID)
        }

        // DADOS VEICULO
        self.setAutoType(obj.autoModel.brand.autoTypeID)
          .then(func => setTimeout(() => {
            self.changeAutoType(obj.autoModel.brand.autoTypeID, func)
          }, 100))
          .catch(function (err) {
            console.log(err)
          })

        // DADOS DA MARCA
        this.pollingBrand = setInterval(() => {
          this.setBrand(obj.autoModel.brandID)
          this.changeBrand(obj.autoModel.brandID)
        }, 500)
        // DADOS DO MODELO
        this.pollingAutoModel = setInterval(() => {
          this.setAuto(obj.autoModel.id)
        }, 500)
      }
    },
    onCheckSinister () {
      var sinister = this.form.sinisterCode.value
      var sinisterVersion = this.form.sinisterVersion.value
      if (sinister && sinisterVersion) {
        loading.push()
        RegulationAutoRepository.GetBySinister(sinister, sinisterVersion)
          .then((response) => {
            if (response) {
              if (response.data.data) {
                var obj = response.data.data
                this.HasSiniter = true
                toast.warning(this.$lang.CarInspection.Register.AlertSinisterHasExist)
                this.onEdit(obj)
                this[RegulationActions.GET_BY_ID](obj.id)
                  .then((response) => {
                  })
              }
            }
            loading.pop()
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        this.HasSiniter = false
      }
    },
    onLoadAllAutoType () {
      loading.push()
      AutoTypeRepository.GetAll()
        .then((response) => {
          this.form.autoTypeID.options = this.onResultDropdown(response, true)
        })
        .catch((err) => {
          this.onException(err)
        })
      this.form.autoTypeID.value = null
    },
    onLoadAllBrand (typeID) {
      this.form.brandID.options = []
      this.form.autoModelID.options = []
      if (typeID) {
        loading.push()
        BrandRepository.GetAllByAutoTypeID(typeID)
          .then((response) => {
            this.form.brandID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
        this.form.brandID.value = null
      }
    },
    onLoadAllAutoModel (brandID) {
      this.form.autoModelID.options = []
      if (brandID) {
        loading.push()
        AutoModelRepository.GetAllByBrandID(brandID)
          .then((response) => {
            this.form.autoModelID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
        this.form.autoModelID.value = null
      }
    },
    onLoadAllBusinessType (insuranceID) {
      this.form.businessTypeID.options = []
      if (insuranceID) {
        loading.push()
        BusinessTypeRepository.GetAllByInsuranceID(insuranceID)
          .then((response) => {
            this.form.businessTypeID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
      this.form.businessTypeID.value = null
    },
    onChangeInsurance () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllBusinessType(self.form.insuranceID.value)
      }, 500)
    },
    onChangeAutoType () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllBrand(self.form.autoTypeID.value)
      }, 500)
    },
    onChangeBrand () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllAutoModel(self.form.brandID.value)
      }, 500)
    },
    onEditMechanicalWorkshop (obj) {
      this.form.mechanicalWorkshopID.value = null
      if (obj) {
        this.form.mechanicalWorkshopID.value = obj.id
        this.mechanicalWorkshop = obj
        this.$emit('Edit', obj)
      }
    },
    setAutoType (autoTypeID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.autoTypeID.value = autoTypeID
          resolve()
        }, 300)
      })
    },
    changeAutoType (autoTypeID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.brandID.options = []
          self.form.autoModelID.options = []
          loading.push()
          BrandRepository.GetAllByAutoTypeID(autoTypeID)
            .then((response) => {
              self.form.brandID.options = self.onResultDropdown(response, true)
            })
            .catch((err) => {
              self.onException(err)
            })
          resolve()
        }, 400)
      })
    },
    setBrand (brandID, resolve) {
      var self = this
      if ((brandID) && (brandID !== '00000000-0000-0000-0000-000000000000')) {
        if (this.form.brandID.options.length > 0) {
          clearInterval(this.pollingBrand)
          return new Promise(function (resolve, reject) {
            setTimeout(function (e) {
              self.form.brandID.value = brandID
              // self.changeBrand(brandID)
              resolve()
            }, 200)
          })
        }
      } else {
        clearInterval(this.pollingBrand)
        self.form.brandID.value = null
      }
    },
    changeBrand (brandID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.autoModelID.options = []
          loading.push()
          AutoModelRepository.GetAllByBrandID(brandID)
            .then((response) => {
              self.form.autoModelID.options = self.onResultDropdown(response, true)
            })
            .catch((err) => {
              self.onException(err)
            })
          resolve()
        }, 800)
      })
    },
    setAuto (autoModelID, resolve) {
      var self = this
      if ((autoModelID) && (autoModelID !== '00000000-0000-0000-0000-000000000000')) {
        if (this.form.autoModelID.options.length > 0) {
          clearInterval(this.pollingAutoModel)
          return new Promise(function (resolve, reject) {
            setTimeout(function (e) {
              self.form.autoModelID.value = autoModelID
              resolve()
            }, 200)
          })
        }
      } else {
        clearInterval(this.pollingAutoModel)
        self.form.autoModelID.value = null
      }
    },
    setBusinessType (businessTypeID, resolve) {
      var self = this
      if ((businessTypeID) && (businessTypeID !== '00000000-0000-0000-0000-000000000000')) {
        if (this.form.businessTypeID.options.length > 0) {
          clearInterval(this.pollingBusinessType)
          return new Promise(function (resolve, reject) {
            setTimeout(function (e) {
              self.form.businessTypeID.value = businessTypeID
              resolve()
            }, 200)
          })
        }
      } else {
        clearInterval(this.pollingBusinessType)
        self.form.businessTypeID.value = null
      }
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i].role === role) {
            result = true
          }
        }
      }
      return result
    },
    onUnlockStage () {
      this.$refs['modal-unlock-regulation'].show()
    },
    onUnlockStageModalClose () {
      this.$refs['modal-unlock-regulation'].hide()
    },
    onUnlockStageModalYes () {
      this.$refs['modal-unlock-regulation'].hide()
      loading.push()
      var id = this.form.id.value
      if (id) {
        RegulationAutoRepository.ChangeStageRegulationToDigitation(id)
          .then((response) => {
            this.onEdit(response.data.data)
            this[RegulationActions.GET_BY_ID](response.data.data.id)
              .then((response) => {
              })
            loading.close()
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch((err) => {
            this.onException(err)
            loading.close()
            toast.error(this.$lang.Common.Alerts.Error)
          })
      } else {
        loading.close()
        toast.error(this.$lang.Common.Alerts.Error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/inspection/register/register.js